import { FC } from 'react';
import PlusButton from '../../../../../../../assets/images/searchBar/plusButton';
import AgentChatMessage from '../AgentChatMessage/AgentChatMessage';
import BordOneToneIcon from '../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import NudosButton from '../../../../../../../components/NudosComponents/NudosButton/NudosButton';
import AgentChatHistorySkeletonLoader from './components/AgentChatHistorySkeletonLoader/AgentChatHistorySkeletonLoader';
import { getHourInAmPmFormat, formatShortDate } from '../../../../../../../utils/formatDatesAndHours';
import { IAgentResponseData } from '../../../../../../../types/agentChat.types';
import './AgentChatHistory.scss';

interface IAgentChatHistoryProps {
  question?: string;
  historyItems: IAgentResponseData[];
  isLoading: boolean;
  handleSetQuestion: (question?: string) => void;
  handleSelectHistoryMessage: (item: IAgentResponseData) => void;
}

const AgentChatHistory: FC<IAgentChatHistoryProps> = ({
  question,
  historyItems,
  isLoading,
  handleSetQuestion,
  handleSelectHistoryMessage
}) => {
  const displayEmptyHistory = !isLoading && !historyItems?.length;

  const getFormattedDate = (item: IAgentResponseData) => {
    const messageDate = new Date(item?.createdAt || '');
    const messageDateIsToday = messageDate.toDateString() === new Date().toDateString();
    return messageDateIsToday
      ? `Hoy - ${getHourInAmPmFormat(item?.createdAt || '')?.onlyHour}`
      : formatShortDate(item?.createdAt || '')?.onlyDate;
  };

  const handleCreateNewChat = () => {
    if (!question || isLoading) return;
    handleSetQuestion(undefined);
  };

  return (
    <div className="agentChatHistory">
      <NudosButton
        buttonText="Nueva consulta"
        handleClick={handleCreateNewChat}
        customClassName="creatButtonWithIcon"
        buttonIcon={<PlusButton className="iconPositionButton" />}
        iconPosition="left"
      />

      <div className="dividerLine" />

      <div className="historyHeader">Consultas previas</div>

      <div className="historyList">
        {isLoading && <AgentChatHistorySkeletonLoader />}

        {displayEmptyHistory && (
          <div className="emptyState">
            <BordOneToneIcon variant="faq" className="faqIcon" />
            En este espacio podrás consultar las preguntas previas realizadas a Bordi
          </div>
        )}

        {!displayEmptyHistory &&
          historyItems?.map(item => {
            const messageDate = getFormattedDate(item);
            return (
              <AgentChatMessage
                key={item?.id}
                messageDate={messageDate}
                message={item?.question}
                handleClick={() => handleSelectHistoryMessage(item)}
                displayHistoryUI
                customClassName="historyItem"
              />
            );
          })}
      </div>
    </div>
  );
};

export default AgentChatHistory;
